/** Shared text colors without renderer or font-loading side effects. */
export const TEXT = {
  mainLight: '#FFFFFF',     // 어두운 배경 위 메인
  mainDark:  '#000000',     // 밝은 배경 위 메인
  subLight:  '#CCD0DE',     // 어두운 배경 위 보조
  subDark:   '#565A6A',     // 밝은 배경 위 보조
  dim:       '#94A3B8',     // 흐린 보조
  veryDim:   'rgba(148,163,184,0.35)',
} as const;
